import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { LOGO_URL, COMPANY } from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0A2540] text-slate-200 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="bg-white inline-block p-3 rounded-md">
              <img src={LOGO_URL} alt="PRISM" className="w-[180px] h-auto max-w-none block" />
            </div>
            <p className="mt-6 text-slate-400 text-base leading-relaxed max-w-md">
              Payment Resolution & IDR System Management. We help healthcare providers
              recover what they're owed under the No Surprises Act through proprietary software
              and white-glove IDR consulting.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-slate-500">Navigate</div>
            <ul className="mt-6 space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/products" className="hover:text-white transition-colors" data-testid="footer-link-products">Products</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-slate-500">Contact</div>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-slate-400" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white" data-testid="footer-email">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-slate-400" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {year} {COMPANY.name} All rights reserved. HIPAA compliant. SOC 2 ready.
          </p>
          <div className="flex gap-6 text-xs text-slate-500">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
            <span>Compliance</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
